import { isoCountries } from './iso2-country-codes';

// ——— Module-scope caching & queues ———
let countryRequest; // the single AJAX Promise
let detectedCountry = null; // Get and store the country from the IP
const phoneInstances = []; // store each intlTelInput instance

function fetchCountryByIp() {
  if (!countryRequest) {
    countryRequest = $.ajax({
      url: 'https://gs-upload.gupshup.io/location?v1',
      method: 'GET',
      dataType: 'json',
    })
      .done((response) => {
        if (response.country) {
          detectedCountry = response.country;
          // update every already-created instance
          phoneInstances.forEach((inst) => inst.setCountry(detectedCountry));
        }
      })
      .fail(() => {
        console.error('Could not detect country via IP');
      });
  }
  return countryRequest;
}

export function initializePhoneNumberInput($input) {
  const $parent = $input.closest('.iti');
  const fallbackCountry = $input.data('selected-country');

  // Determine initialCountry: use detectedCountry if already fetched,
  // otherwise fall back to the data attribute
  const initialCountry = detectedCountry || fallbackCountry;

  if (!$parent.hasClass('iti--show-flags')) {
    // eslint-disable-next-line no-undef
    const SFDCPhoneNumber = intlTelInput($input[0], {
      onlyCountries: [
        'AF',
        'AX',
        'AL',
        'DZ',
        'AS',
        'AD',
        'AO',
        'AI',
        'AQ',
        'AG',
        'AR',
        'AM',
        'AW',
        'AU',
        'AT',
        'AZ',
        'BS',
        'BH',
        'BD',
        'BB',
        'BY',
        'BE',
        'BZ',
        'BJ',
        'BM',
        'BT',
        'BO',
        'BA',
        'BW',
        'BV',
        'BR',
        'IO',
        'BN',
        'BG',
        'BF',
        'BI',
        'KH',
        'CM',
        'CA',
        'CV',
        'KY',
        'CF',
        'TD',
        'CL',
        'CN',
        'CX',
        'CC',
        'CO',
        'KM',
        'CG',
        'CD',
        'CK',
        'CR',
        'CI',
        'HR',
        'CU',
        'CW',
        'CY',
        'CZ',
        'DK',
        'DJ',
        'DM',
        'DO',
        'EC',
        'EG',
        'SV',
        'GQ',
        'ER',
        'EE',
        'ET',
        'FK',
        'FO',
        'FJ',
        'FI',
        'FR',
        'GF',
        'PF',
        'TF',
        'GA',
        'GM',
        'GE',
        'DE',
        'GH',
        'GI',
        'GR',
        'GL',
        'GD',
        'GP',
        'GU',
        'GT',
        'GG',
        'GN',
        'GW',
        'GY',
        'HT',
        'HM',
        'HN',
        'HK',
        'HU',
        'IS',
        'IN',
        'ID',
        'IR',
        'IQ',
        'IE',
        'IL',
        'IT',
        'JM',
        'JP',
        'JE',
        'JO',
        'KZ',
        'KE',
        'KI',
        'KW',
        'KG',
        'LA',
        'LV',
        'LB',
        'LS',
        'LR',
        'LY',
        'LI',
        'LT',
        'LU',
        'MO',
        'MK',
        'MG',
        'MW',
        'MY',
        'MV',
        'ML',
        'MT',
        'MH',
        'MQ',
        'MR',
        'MU',
        'YT',
        'MX',
        'FM',
        'MD',
        'MC',
        'MN',
        'ME',
        'MS',
        'MA',
        'MZ',
        'MM',
        'NA',
        'NP',
        'NL',
        'AN',
        'NC',
        'NZ',
        'NI',
        'NE',
        'NG',
        'NU',
        'NF',
        'MP',
        'NO',
        'OM',
        'PK',
        'PW',
        'PS',
        'PA',
        'PG',
        'PY',
        'PE',
        'PH',
        'PL',
        'PT',
        'PR',
        'QA',
        'RE',
        'RO',
        'RU',
        'RW',
        'SH',
        'KN',
        'LC',
        'MF',
        'PM',
        'VC',
        'WS',
        'SM',
        'ST',
        'SA',
        'SN',
        'CS',
        'SC',
        'SL',
        'SG',
        'SX',
        'SK',
        'SI',
        'SB',
        'SO',
        'ZA',
        'GS',
        'ES',
        'LK',
        'SD',
        'SR',
        'SJ',
        'SZ',
        'SE',
        'CH',
        'SY',
        'TW',
        'TJ',
        'TZ',
        'TH',
        'TG',
        'TK',
        'TO',
        'TT',
        'TN',
        'TR',
        'TM',
        'TC',
        'TV',
        'UG',
        'UA',
        'AE',
        'GB',
        'UY',
        'US',
        'UZ',
        'VU',
        'VE',
        'VN',
        'VI',
        'WF',
        'YE',
        'ZM',
        'ZW',
      ],
      utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
      initialCountry,
      autoInsertDialCode: true,
    });

    phoneInstances.push(SFDCPhoneNumber);

    // use promise to ensure caching
    fetchCountryByIp();

    return SFDCPhoneNumber;
  }
}

export function setupPhoneInputEvents($input) {
  const SFDCPhoneNumber = initializePhoneNumberInput($input);

  $input.on('input', function () {
    const fullNumber = SFDCPhoneNumber.getNumber();
    const countryName = isoCountries[SFDCPhoneNumber.s.iso2.toUpperCase()];
    const nearestCountryHiddenInput = $(this).closest('form').find('.00N5g00000OZ5f1');

    $(this).val(fullNumber);
    nearestCountryHiddenInput.val(countryName);
  });

  $input.on('countrychange', function () {
    const countryName = isoCountries[SFDCPhoneNumber.s.iso2.toUpperCase()];

    const nearestCountryHiddenInput = $(this).closest('form').find('.00N5g00000OZ5f1');
    nearestCountryHiddenInput.val(countryName);
  });
}
